<template>
  <div :style="{width:width+'px',height:height+'px'}" :id="uuid" @contextmenu.prevent></div>
</template>

<script setup>
import {getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty } from "@/utils/refresh-cpt-data";
import {getCodeByName, registerMap} from "@/utils/map-manage";
import {onMounted, watch, computed} from "vue";
import * as echarts from 'echarts'
// import chinaGeoJson from '@/assets/map/china.json'
// const chinaGeoJsonPromise = () => import('@/assets/map/china.json')
const loadChinaGeoJson = async () => {
     const { default: chinaGeoJson } = await import('@/assets/map/china.json');
     return chinaGeoJson;
   };
const props = defineProps({
  width:Number,
  height:Number,
  option:Object,
  components:Array,
  current: Object
})
// 新增属性兼容旧代码
const attr = props.option.attribute
if (!attr.globalDataReload) attr.globalDataReload = [0]

let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(() => props.current.cptShow,(val)=>{
    if (val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  watch(() => props.option.attribute.hideCompInTabw,(val)=>{
    if (!val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
// watch(() => props.option.attribute, (obj) => {
//   processData(props.option.cptDataForm,newData,jsFunFlag)
//   loadChart(obj);
// },{deep:true})
watch(() => [props.width,props.height], () => {
  chart.resize()
})

let uuid = require('uuid').v1();
let chartOption = {};
let chart = null
let cptData = [];
let lastCityCode = '';//地图下钻记录上一级
let newData = "";
let jsFunFlag = false;
const emit = defineEmits(['clickHandler'])

onMounted(()=>{
  // echarts.registerMap('china', loadChinaGeoJson);
  loadChinaGeoJson().then(chinaJson => {
    echarts.registerMap('china', chinaJson);
    let element = document.getElementById(uuid)
    if(!element) {
      return
    }
    chart = echarts.init(element)
    if (dataReload.value.includes(0)) {
      refreshCptData();
    }
    drillDown()
  });
  
})

function refreshCptData(cptDataForm = props.option.cptDataForm,paras){
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm,paras),
  props.components)
}
function loadData(cptDataForm,paras){
  getDataJson(cptDataForm,paras,(res)=> {
            newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
        jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
        processData(cptDataForm,newData,jsFunFlag)
        // cptData = res;
        loadChart(props.option.attribute);

      })
}
function processData(cptDataForm,res,jsFunFlag){
          // 第一层判断 如果选择数据集
          if(cptDataForm.dataSource == '4') {
            // 第二层判断 ，如果没有配转换脚本
            if(jsFunFlag) { // 没有全部配置映射字段
                if(hasNonEmptyValues(props.option.attribute.cptTableData)) {
                    const dataKey = props.option.attribute.cptTableData;
                     let newarr = [];
                      // 遍历原始数组并重组数据
                        res.forEach(item => {
                          let name = item[dataKey[0].value];
                          let value = item[dataKey[1].value];

                          // 创建新的对象并添加到 aa 数组中
                          newarr.push({ name, value });
                        });
                        console.log(newarr,'新数组')
                        cptData = newarr; 
              }
             } else { // 如果配置了转换脚本
                cptData = res;
             }
          } else { // 不是数据集类型，是静态数据
               cptData = res;
          } 
  }
function loadChart(attribute) {
  let temp = attribute.tipFormatter.split('${');
  let tipList = [];
  for (let i = 1; i < temp.length; i++) {
    let item = temp[i];
    const key = item.substr(0,item.indexOf('}'));
    const str = item.substr(item.indexOf('}')+1);
    tipList.push({key:key,str:str})
  }
  let pieces = JSON.parse(JSON.stringify(attribute.visualMap.pieces))
  for (let i = 0; i < pieces.length; i++) {
    pieces[i].color = attribute.color[i]
  }
  registerMap(attribute.provinceCode,attribute.cityCode).then(cityCode => {
    chartOption = {
      title : {
        text: attribute.titleText,
        //subtext: attribute.subtext,
        left: attribute.titleLeft,
        top: attribute.titleTop,
        textStyle : {
          color: attribute.titleColor,
          fontSize: attribute.titleFontSize
        },
        // subtextStyle: {
        //   color: attribute.subTitleColor,
        //   fontSize: attribute.subTitleFontSize
        // }
      },
      tooltip: {
        formatter: function(e) {
          if(!e.data) return '';
          let str = temp[0];
          tipList.forEach(item => {
            str += e.data[item.key]+item.str
          })
          return str
        }
      },
      visualMap: {
        min: attribute.visualMap.min,
        max: attribute.visualMap.max,
        left: attribute.visualMap.left,
        top: attribute.visualMap.top,
        showLabel: true,
        text: attribute.visualMap.text,
        textStyle:attribute.visualMap.textStyle,
        pieces: pieces,
        show: attribute.visualMap.show
      },
      geo: {
        map: cityCode,
        roam: attribute.roam,//允许缩放
        //scaleLimit: { min: 1, max: 2 },//允许缩放级别
        zoom: attribute.geoZoom?attribute.geoZoom:1.23,
        center:[attribute.geoLeft || 100,attribute.geoTop || 30],
        label: {
          show: true,
          fontSize: attribute.geoLabelSize,
          color: attribute.geoLabelColor
        },
        itemStyle: {
          borderColor: attribute.borderColor,//边界线颜色
          color: attribute.areaColor
        },
      },
      series: [{
        // name: attribute.seriesName,
        type: "map",
        geoIndex: 0,
        data: cptData
      }]
    }
    chart.setOption(chartOption);
  })
}
function drillDown(){
  chart.on('click', function (params) {//点击下钻
    emit("clickHandler",props.option.interaction,'default',params.name)//组件交互
    if(props.option.attribute.enableDrillDown){
      let code = getCodeByName(params.name,chartOption.geo.map);
      if (code != null){
        chart.clear()
        registerMap(code).then(cityCode => {
          lastCityCode = chartOption.geo.map;//记录下钻前的code
          chartOption.geo.map = cityCode;
          chart.setOption(chartOption);
        })
      }
    }
  });
  if(props.option.attribute.enableDrillDown){
    chart.on('contextmenu', () => {
      let code = lastCityCode
      if(!lastCityCode){
        code = props.option.attribute.provinceCode
      }
      if(chartOption.geo.map !== 'china'){
        chart.clear();
        if(chartOption.geo.map === code){
          code = 'china'
        }
        registerMap(code).then(cityCode => {
          chartOption.geo.map = cityCode;
          chart.setOption(chartOption);
        })
      }
    })
  }
}

defineExpose({refreshCptData})
</script>

<style scoped>

</style>
